<script setup lang="ts">
import { useStore } from 'vuex'
import { ref, computed, onMounted, onUnmounted } from 'vue'

import { EPINIO_TYPES } from '../types'

import Loading from '@shell/components/Loading.vue'
import { startPolling, stopPolling } from '../utils/polling';

const store = useStore()
const props = defineProps<{ schema: object }>(); // eslint-disable-line @typescript-eslint/no-unused-vars

const pending = ref(true);
const searchQuery = ref(null);

onMounted(async () => {
  await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.CATALOG_SERVICE });
  pending.value = false;

  startPolling(["namespaces", "applications", "catalogservices", "services"], store);
});

onUnmounted(() => {
  stopPolling(["namespaces", "applications", "catalogservices", "services"]);
});

const list = computed(() => {
  const catalogList = store.getters['epinio/all'](EPINIO_TYPES.CATALOG_SERVICE)

  if (!searchQuery.value) {
    return catalogList;
  } else {
    const query = searchQuery.value.toLowerCase();

    return catalogList.filter((e) => e?.chart.toLowerCase().includes(query) ||
      e?.description.toLowerCase().includes(query) ||
      e?.short_description.toLowerCase().includes(query));
  }
})

const showDetails = (chart: any) => {
  store.$router.push(chart.detailLocation)
}

</script>

<template>
  <Loading v-if="pending" />
  <div v-else>
    <div id="modal-container-element" class="filter-block">
      <trailhand-text-input
        v-model="searchQuery"
        type="search"
        class="input-sm"
        :placeholder="t('catalog.charts.search')"
      />
    </div>

    <div class="cards-container">
      <trailhand-card
        v-for="service in list"
        :key="service.id"
        :card-title="service.meta.name"
        :description="service.short_description"
        :icon-src="service.serviceIcon ? service.serviceIcon : null"
        :icon-name="service.serviceIcon ? null : 'database'"
        clickable
        @click="showDetails(service)"
      >
    </trailhand-card>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.filter-block {
  display: flex;
  justify-content: flex-end;
  input {
    width: 315px;
  }
}

.cards-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 16px;
}

@media (max-width: 992px) {
  .cards-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .cards-container {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
